<div class="app-shell">
  <aside class="sidebar">
    <div class="brand">{{ title() }}</div>
    <nav class="side-nav">
      <a routerLink="/config" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">JSON → JSON</a>
      <a routerLink="/csv-config" routerLinkActive="active">CSV→JSON</a>
      <a routerLink="/fixed-config" routerLinkActive="active">固定長→JSON</a>
      <a routerLink="/json-to-fixed-config" routerLinkActive="active">JSON→固定長</a>
      <a routerLink="/new-mapping" routerLinkActive="active">新規マッピング</a>
      <a routerLink="/mapping-screen" routerLinkActive="active">ViewSchema GUI</a>
      <a routerLink="/transfer" routerLinkActive="active">ファイル転送</a>
    </nav>
  </aside>
  <main class="content-area">
    <router-outlet />
  </main>
</div>
<app-toast />
